export default [
  {
    position: "absolute",
    top: 21.5,
    left: 13,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    isAction: true,
    mTitle: "analyticsMoreP2.mTitleOne",
    mBody: "analyticsMoreP2.mBodyOne",
    id: "SP_HowManyinTeams_Action_Charts",
    plusIcon: true,
    index: 0
  },
  {
    position: "absolute",
    top: 35,
    left: 59,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "analyticsMoreP2.mTitleTwo",
    mBody: "analyticsMoreP2.mBodyTwo",
    id: "SP_HowManyinTeams_Info_ChartsValues",
    infoIcon: true,
    isAction: false,
    index: 1
  },
  {
    position: "absolute",
    top: 69.7,
    left: 61,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-bottom-right",
    isDialog: true,
    modal: false,
    mTitle: "analyticsMoreP2.mTitleThree",
    mBody: "analyticsMoreP2.mBodyThree",
    id: "SP_HowManyinTeams_Info_ChartsKey",
    infoIcon: true,
    isAction: false,
    index: 2
  },
  {
    position: "absolute",
    top: 0.7,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "analyticsMoreP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_HowManyinTeams_Navigation_Menu",
    index: 3
  },
  {
    position: "absolute",
    top: 0.7,
    left: 23,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "analyticsMoreP2.ttTextSix",
    hover: false,
    id: "SP_HowManyinTeams_Navigation_Communications",
    index: 4
  },
  {
    position: "absolute",
    top: 5.4,
    left: 40.1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 12,
    tooltipText: "analyticsMoreP2.ttTextFive",
    hover: false,
    id: "SP_HowManyinTeams_Navigation_Analytics",
    index: 5
  },
  {
    position: "absolute",
    top: 4.1,
    left: 98.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "analyticsMoreP2.ttTextFour",
    hover: false,
    id: "SP_HowManyinTeams_Navigation_TeamMember",
    index: 6
  },
];
